import { LockKeyhole, LockKeyholeOpen } from "lucide-react";
import type { JSX } from "react";

import type { ShareDTO } from "../api/types.js";

export type ShareVisibility = "public" | "tenant" | "restricted";

export function visibilityFromShares(shares: readonly ShareDTO[]): ShareVisibility {
  if (shares.some((share) => share.subject === "PUBLIC")) return "public";
  return shares.some((share) => share.subject === "TENANT") ? "tenant" : "restricted";
}

const presentation = {
  public: { label: "Öffentlich freigegeben", className: "text-emerald-600", Icon: LockKeyholeOpen },
  tenant: { label: "Im Unternehmen freigegeben", className: "text-amber-500", Icon: LockKeyholeOpen },
  restricted: { label: "Freigabe eingeschränkt", className: "text-danger", Icon: LockKeyhole },
} as const;

export function ShareStatusIcon({ visibility, className = "h-4 w-4" }: { visibility: ShareVisibility; className?: string }): JSX.Element {
  const { label, className: color, Icon } = presentation[visibility];
  return <Icon aria-label={label} role="img" className={`${className} ${color}`} />;
}

export function shareVisibilityLabel(visibility: ShareVisibility): string {
  return presentation[visibility].label;
}
